import { render, staticRenderFns } from "./CollectionModal.vue?vue&type=template&id=31990dde"
import script from "./CollectionModal.vue?vue&type=script&lang=js"
export * from "./CollectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports